export default __webpack_public_path__ + "static/media/Background_00124.ad6ff544.png";